import { useState } from "react";

const EditFamilyModal = ({ member, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: member?.name || '',
    relationship: member?.relationship || 'spouse',
    birth_date: member?.birth_date?.substring(0, 10) || '',
    nif: member?.nif || '',
    is_dependent: member?.is_dependent || false,
    education_level: member?.education_level || ''
  });

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-lg" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-700">
          <h3 className="text-xl font-bold text-white">Editar Membro</h3>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Nome *</label>
            <input
              type="text"
              value={formData.name}
              onChange={e => setFormData({...formData, name: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Parentesco</label>
            <select
              value={formData.relationship}
              onChange={e => setFormData({...formData, relationship: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
            >
              <option value="spouse">Cônjuge</option>
              <option value="child">Filho(a)</option>
              <option value="parent">Pai/Mãe</option>
              <option value="sibling">Irmão/Irmã</option>
              <option value="other">Outro</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Data de Nascimento *</label>
            <input
              type="date"
              value={formData.birth_date}
              onChange={e => setFormData({...formData, birth_date: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              required
            />
            <p className="text-xs text-slate-500 mt-1">Obrigatório para validação de benefícios</p>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">NIF</label>
            <input
              type="text"
              value={formData.nif}
              onChange={e => setFormData({...formData, nif: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              placeholder="123456789"
              maxLength={9}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Nível de Escolaridade</label>
            <select
              value={formData.education_level}
              onChange={e => setFormData({...formData, education_level: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
            >
              <option value="">N/A</option>
              <option value="primary">Ensino Básico</option>
              <option value="secondary">Ensino Secundário</option>
              <option value="university">Licenciatura</option>
              <option value="masters">Mestrado</option>
              <option value="phd">Doutoramento</option>
            </select>
            <p className="text-xs text-slate-500 mt-1">Relevante para benefícios de estudantes até 25 anos</p>
          </div>
          
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_dependent}
              onChange={e => setFormData({...formData, is_dependent: e.target.checked})}
              className="w-4 h-4 rounded"
            />
            <span className="text-sm text-slate-300">É dependente fiscal</span>
          </label>
        </div>
        
        <div className="p-6 border-t border-slate-700 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg bg-slate-700 text-white hover:bg-slate-600">
            Cancelar
          </button>
          <button
            onClick={() => onSave(member.member_id, formData)}
            disabled={!formData.name || !formData.birth_date}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-50"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditFamilyModal;
